import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { SupabaseClientService } from '@services/db/supabase-client';
import { environment } from '@app/environment';

/**
 * Supabase Authentication Interceptor
 * 
 * Automatically adds JWT token and apikey to all requests to Supabase
 */
export const supabaseAuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (!req.url.startsWith(environment.supabase.url)) {
    return next(req);
  }

  const supabase = inject(SupabaseClientService);

  return from(supabase.client.auth.getSession()).pipe(
    switchMap(session => {
      const token = session.data.session?.access_token;
      if (!token) {
        return throwError(() => new Error('User is not authenticated'));
      }

      const authReq = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          'apikey': environment.supabase.publicKey,
        }
      });

      return next(authReq);
    }),
    catchError(error => {
      console.error('[Supabase Auth Interceptor] Error:', error);
      return throwError(() => error);
    })
  );
};
